import React from 'react';
import { View } from 'react-native';
import { bars_enam, round_enam } from '../../utils/DictionaryManagementUtils';
import ServiceBtnLayout from './ServiceBtnLayout';

//= ========================================================================

const MenuServicesLayout = ({
  globJSON, multi = 1, showAllServices,
}) => {
  const { icon_shape_bars_enam } = globJSON.configurations.services.menu;
  const isBars = icon_shape_bars_enam === bars_enam;
  const isRound = icon_shape_bars_enam === round_enam;
  const maxServices = 2;
  const styles = {
    menuContainer: {
      paddingStart: (multi ** 0.8) * 14,
      paddingEnd: (multi ** 0.8) * 14,
      paddingTop: !showAllServices ? (multi) * 18 : (multi) * 12,
      gap: !showAllServices && 6,
      display: 'flex',
      flexDirection: isBars ? 'column' : 'row',
      flexWrap: 'wrap',
    },
  };

  return (
    <View style={styles.menuContainer}>
      {globJSON.configurations.services.screens_ordering
        .filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
        .filter((serviceKey, index) => (index < maxServices || showAllServices))
        .map((serviceKey) => (
          <ServiceBtnLayout
            globJSON={globJSON}
            service={globJSON.configurations.services[serviceKey]}
            isBars={isBars}
            isRound={isRound}
            multi={multi}
            key={serviceKey}
          />
        ))}
    </View>
  );
};
export default MenuServicesLayout;
